<template>
  <div class="userManagePage">
    <div class="header">
      <el-tabs :value="tabPaneValue" @tab-click="tabPaneClick">
        <el-tab-pane label="组织结构" name="first">
          <span
            class="childTabs"
            :class="{ activeLink: settingType == 'orgTable' }"
            @click="settingChange('orgTable')"
            >组织结构</span
          >
          <span
            class="childTabs"
            :class="{ activeLink: settingType == 'orgTree' }"
            @click="settingChange('orgTree')"
            >组织结构树</span
          >
          <span
            class="childTabs"
            :class="{ activeLink: settingType == 'orgTypeTable' }"
            @click="settingChange('orgTypeTable')"
            >组织结构类别</span
          >
          <span
            class="childTabs"
            :class="{ activeLink: settingType == 'orgTypeTree' }"
            @click="settingChange('orgTypeTree')"
            >组织结构类别树</span
          >
          <div class="btnBox">
            <el-button
              v-if="settingType == 'orgTree' || settingType == 'orgTypeTree'"
              type="primary"
              icon="el-icon-download"
              size="small"
              @click="downloadTreeImg"
              >导出</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="small"
              @click="addNewBtn"
              >新建</el-button
            >
          </div>
        </el-tab-pane>
        <el-tab-pane label="用户管理" name="user">
          <!-- <span class="activeLink">用户管理</span> -->
          <span
            class="childTabs"
            :class="{ activeLink: userType == 'userManage' }"
            @click="userTypeChange('userManage')"
            >用户管理</span
          >
          <span
            class="childTabs"
            :class="{ activeLink: userType == 'workPosition' }"
            @click="userTypeChange('workPosition')"
            >岗位</span
          >
          <span
            class="childTabs"
            :class="{ activeLink: userType == 'workPositionType' }"
            @click="userTypeChange('workPositionType')"
            >岗位类别</span
          >
          <div class="btnBox">
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-tooltip
                class="item"
                content="清除查询条件"
                placement="bottom"
                :open-delay="300"
              >
                <el-button
                  icon="iconfont icon-qingkong"
                  size="small"
                  class="cleanBox"
                  @click="onClear"
                ></el-button
                >>
              </el-tooltip>
              <el-button
                type="primary"
                icon="el-icon-search"
                size="small"
                @click="onSearch"
                >查询</el-button
              >
            </div>
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="small"
              @click="addNewBtn"
              >新建</el-button
            >
            <el-tooltip
              class="item"
              content="查询条件"
              placement="bottom"
              :open-delay="300"
            >
              <el-button
                class="btn_more"
                :class="{ activeUserMore: isMoreSearch }"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-form
        :inline="true"
        :model="searchConditionForm"
        class="demo-form-inline"
        v-if="
          tabPaneValue == 'user' && userType == 'userManage' && isMoreSearch
        "
        key="userManage"
      >
        <div class="searchConditionBox">
          <el-form-item label="工号" size="small">
            <el-input
              v-model="searchConditionForm.employeeNum"
              placeholder="用户工号"
              clearable
              @keyup.enter.native="getUserSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="姓名" size="small">
            <el-input
              v-model="searchConditionForm.name"
              placeholder="姓名"
              clearable
              @keyup.enter.native="getUserSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="邮箱" size="small">
            <el-input
              size="small"
              v-model="searchConditionForm.email"
              placeholder="用户邮箱"
              clearable
              @keyup.enter.native="getUserSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号" size="small">
            <el-input
              size="small"
              v-model="searchConditionForm.phoneNum"
              placeholder="输入手机号码"
              clearable
              @keyup.enter.native="getUserSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="岗位" size="small">
            <el-select
              v-model="searchConditionForm.workPositionId"
              placeholder="选择岗位"
              filterable
              clearable
            >
              <el-option-group
                v-for="group in positionList"
                :key="group.label"
                :label="group.label"
              >
                <el-option
                  v-for="item in group.options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item label="状态" size="small">
            <el-select
              v-model="searchConditionForm.enable"
              placeholder="选择状态"
              filterable
              clearable
            >
              <el-option label="启用" :value="true"></el-option>
              <el-option label="禁用" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="SAP操作" size="small">
            <el-select
              v-model="searchConditionForm.sap"
              placeholder="是否支持SAP操作"
              filterable
              clearable
            >
              <el-option label="启用" :value="true"></el-option>
              <el-option label="禁用" :value="false"></el-option>
            </el-select>
          </el-form-item>          
          <el-form-item label="SAP工厂" size="small">
            <el-input size="small" v-model="searchConditionForm.sapWerks" placeholder="SAP工厂代码"
              clearable @keyup.enter.native="getUserSearch()"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <el-form
        :inline="true"
        :model="positionSearchForm"
        class="demo-form-inline"
        v-else-if="
          tabPaneValue == 'user' && userType == 'workPosition' && isMoreSearch
        "
        key="workPosition"
      >
        <div class="searchConditionBox">
          <el-form-item label="岗位名称" size="small">
            <el-input
              v-model="positionSearchForm.name"
              placeholder="输入岗位名称"
              clearable
              @keyup.enter.native="$refs.WorkPositionPage.getPositionSearch()"
            ></el-input>
            <el-input v-show="false"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <el-form
        :inline="true"
        :model="positionTypeSearchForm"
        class="demo-form-inline"
        v-else-if="
          tabPaneValue == 'user' &&
          userType == 'workPositionType' &&
          isMoreSearch
        "
        key="workPositionType"
      >
        <div class="searchConditionBox">
          <el-form-item label="岗位类别" size="small">
            <el-input
              v-model="positionTypeSearchForm.name"
              placeholder="输入岗位类别名称"
              clearable
              @keyup.enter.native="$refs.WorkPositionTypePage.getPositionTypeSearch()"
            ></el-input>
            <el-input v-show="false"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div
        class="tips tipsBox"
        v-show="
          tabPaneValue == 'first' &&
          (settingType == 'orgTree' || settingType == 'orgTypeTree') &&
          isShowTips
        "
      >
        <span class="title">温馨提示：</span>
        <span class="text">双击标签可操作！</span>
        <i class="el-icon-close close" @click="closeTips"></i>
      </div>
    </div>
    <div class="contentBox" v-if="tabPaneValue == 'first'">
      <div class="rightContent" v-if="settingType == 'orgTable'">
        <el-table
          stripe
          :data="orgTableData"
          style="width: 100%"
          border
          height="100%"
          size="mini"
          row-key="id"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          default-expand-all
        >
          <el-table-column
            type="index"
            width="50"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="name"
            label="组织名称"
            min-width="110"
            header-align="center"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="typeId"
            label="组织类别"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.type">{{ scope.row.type.name }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="enable"
            label="状态"
            align="center" width="95px" 
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span class="textSuccess" v-if="scope.row.enable">启用</span>
              <span class="textWarning" v-else>禁用</span>
            </template>
          </el-table-column>
          <el-table-column class-name="operation"
            label="操作" align="center" width="130px">
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="新建"
                placement="top"
                :open-delay="300"
              >
                <i
                  @click="addNewBtn($event, scope.row)"
                  class="el-icon-plus"
                ></i>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="修改"
                placement="top"
                :open-delay="300"
              >
                <i
                  @click="editOrgInfo($event, scope.row)"
                  class="el-icon-edit"
                ></i>
              </el-tooltip>
              <el-tooltip
                v-if="scope.row.enable"
                class="item"
                effect="dark"
                content="禁用"
                placement="top"
                :open-delay="300"
              >
                <i
                  @click="disableOrg($event, scope.row)"
                  class="iconfont icon-jinyong"
                ></i>
              </el-tooltip>
              <el-tooltip
                v-else
                class="item"
                effect="dark"
                content="启用"
                placement="top"
                :open-delay="300"
              >
                <i
                  @click="enableOrg($event, scope.row)"
                  class="iconfont icon-qiyong"
                ></i>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="上移"
                placement="top"
                :open-delay="300"
              >
                <i
                  @click="moveUpOrg($event, scope.row)"
                  class="el-icon-arrow-up"
                ></i>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="下移"
                placement="top"
                :open-delay="300"
              >
                <i
                  @click="moveDownOrg($event, scope.row)"
                  class="el-icon-arrow-down"
                ></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="rightContent" v-else-if="settingType == 'orgTree'">
        <orgTreePage ref="orgTreePage"></orgTreePage>
      </div>
      <div class="rightContent" v-else-if="settingType == 'orgTypeTable'">
        <orgTypePage ref="orgTypePage"></orgTypePage>
      </div>
      <div class="rightContent" v-else-if="settingType == 'orgTypeTree'">
        <orgTypeTreePage ref="orgTypeTreePage"></orgTypeTreePage>
      </div>
    </div>
    <template v-else-if="tabPaneValue == 'user'">
      <div class="contentBox" v-if="userType == 'userManage'">
        <div class="leftContent">
          <p class="title">
            <span>组织结构</span>
            <!-- <i class="el-icon-circle-plus-outline"></i> -->
          </p>
          <el-tree
            ref="tree"
            :data="orgList"
            :props="defaultProps"
            @node-click="handleNodeClick"
            highlight-current
            node-key="id"
            :default-expanded-keys="[currentDeptId]"
            :current-node-key="currentDeptId"
          >
          </el-tree>
        </div>
        <div class="rightContent">
          <el-table
            stripe
            :data="tableData"
            border
            style="width: 100%"
            height="100%"
            size="mini"
            @sort-change="sortChange"
          >
            <el-table-column
              type="index"
              width="50"
              align="center"
              :index="pagination.beginIndex"
            ></el-table-column>
            <el-table-column
              prop="employeeNum"
              label="工号"
              align="center"
              sortable="custom"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span :class="{disabled_user: !scope.row.enable}">{{ scope.row.employeeNum}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="姓名"
              align="center"
              sortable="custom"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="organization"
              label="所属部门"
              align="center"
              show-overflow-tooltip
              min-width="150"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.organization">{{
                  scope.row.organization.name
                }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="email"
              label="邮箱"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span v-if="scope.row.email" :class="{disabled_user: !scope.row.enable}">{{ scope.row.email }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="workPosition"
              label="岗位"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span v-if="scope.row.workPosition" :class="{disabled_user: !scope.row.enable}">{{
                  scope.row.workPosition.name
                }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="isManager"
              label="是否管理员"
              align="center"
              min-width="100"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span :class="{disabled_user: !scope.row.enable}">{{ scope.row.isManager ? "管理员" : "否" }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="isAllowLogin" label="后台登录" align="center">
              <template slot-scope="scope">
                <span :class="{disabled_user: !scope.row.enable}">{{ scope.row.isAllowLogin ? "允许" : "禁止" }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="isLoginTest" label="测试环境" align="center">
              <template slot-scope="scope">
                <span :class="{disabled_user: !scope.row.enable}">{{ scope.row.isLoginTest ? "允许" : "禁止" }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="isSap" label="SAP操作" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="scope.row.sapWerks" :class="{disabled_user: !scope.row.enable}">{{ scope.row.isSap ? "允许("+scope.row.sapWerks+")" : "禁止" }}</span>
                <span v-else :class="{disabled_user: !scope.row.enable}">{{ scope.row.isSap ? "允许" : "禁止" }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="createDateTime" label="注册时间" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span :class="{disabled_user: !scope.row.enable}">{{ scope.row.createDateTime }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="enable"
              label="状态"
              align="center" width="95px" 
              sortable="custom"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span :class="{disabled_user: !scope.row.enable}">{{ scope.row.enable ? "启用" : "禁用" }}</span>
              </template>
            </el-table-column>
            <el-table-column
              class-name="operation"
              label="操作"
              align="center"
              width="130px"
            >
              <template slot-scope="scope">
                <el-tooltip v-if="scope.row.enable"
                  class="item"
                  effect="dark"
                  content="修改用户信息"
                  placement="top"
                  :open-delay="300"
                >
                  <i
                    @click="handleEditInfo(scope.row)"
                    class="operation el-icon-edit"
                  ></i>
                </el-tooltip>
                <el-tooltip v-if="scope.row.enable"
                  class="item"
                  effect="dark"
                  content="重置用户密码"
                  placement="top"
                  :open-delay="300"
                >
                  <i
                    @click="resetUserPassword(scope.row)"
                    class="iconfont icon-zhongzhimima"
                  ></i>
                </el-tooltip>
                <el-tooltip
                  v-if="scope.row.enable"
                  class="item"
                  effect="dark"
                  content="禁用"
                  placement="top"
                  :open-delay="300"
                >
                  <i
                    @click="disableUser($event, scope.row)"
                    class="iconfont icon-jinyong"
                  ></i>
                </el-tooltip>
                <el-tooltip
                  v-else
                  class="item"
                  effect="dark"
                  content="重新启用"
                  placement="top"
                  :open-delay="300"
                >
                  <i
                    @click="enableUser($event, scope.row)"
                    class="iconfont icon-chongqi"
                  ></i>
                </el-tooltip>
                <el-tooltip
                  v-if="scope.row.enable"
                  class="item"
                  effect="dark"
                  content="工作交接"
                  placement="top"
                  :open-delay="300"
                >
                  <i
                    @click="handover($event, scope.row)"
                    class="iconfont icon-jiaojie"
                  ></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            :pagination="pagination"
            @currentChange="currentChange"
            @sizeChange="sizeChange"
            @refreshBtn="getUserSearch"
          ></pagination>
        </div>
      </div>
      <WorkPositionPage
        v-else-if="userType == 'workPosition'"
        ref="WorkPositionPage"
        :positionSearchForm="positionSearchForm"
      ></WorkPositionPage>
      <WorkPositionTypePage
        v-else-if="userType == 'workPositionType'"
        ref="WorkPositionTypePage"
        :positionTypeSearchForm="positionTypeSearchForm"
      ></WorkPositionTypePage>
    </template>
    <myDialog
      ref="myDialog"
      :title="dialogTitle"
      @submitData="submitData"
      @dialogClose="dialogClose"
      width="450px"
    >
      <template slot="content">
        <div v-if="tabPaneValue == 'user' && dialogTitle == '工作交接'">          
          <el-form
            ref="dialogForm"
            :model="HandoverForm"
            :rules="dialogRules"
            :label-width="labelWidth"
          >
            <div v-if="dialogTitle == '工作交接'" key="pe">
              <el-form-item
                label="接收人："
                size="small"
                prop="userId"
              >
              <el-select
                v-model="HandoverForm.userId"
                placeholder="选择接收工作的用户"
                filterable
                clearable
                class="hiddenSelectDropdown"
                :popper-append-to-body="false"
                @visible-change="
                  selectVisible($event, 'user', '员工选择', 'HandoverForm')
                "
              >
                <el-option
                  v-for="(item, index) in pullDownData.userList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div
          class="tips"
          v-else-if="tabPaneValue == 'user' && dialogTitle == '修改用户'"
        >
          <span class="title">温馨提示：</span>修改用户后，登录状态会被注销！
        </div>
        <div
          class="tips"
          v-else-if="tabPaneValue == 'user' && dialogTitle == '重置用户密码'"
        >
          <span class="title">温馨提示：</span>重置密码后，登录状态会被注销！
        </div>
        <el-form
          ref="orgDialogForm"
          :model="orgDialogForm"
          :rules="orgDialogRules"
          :label-width="labelWidth"
          v-if="tabPaneValue == 'first'"
          :key="1"
        >
          <div
            v-if="settingType == 'orgTable' || settingType == 'orgTree'"
            :key="1"
          >
            <el-form-item label="组织名称" size="small" prop="name">
              <el-input
                v-model="orgDialogForm.name"
                placeholder="组织结构名称(工厂、车间/仓库、拉线、工序等)"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="上级组织" size="small" prop="parentId">
              <el-cascader
                :options="pullDownData.orgOptions"
                :props="cascaderOption"
                :show-all-levels="false"
                v-model="orgDialogForm.parentId"
                @change="cascaderChange($event, 'parentCascader')"
                ref="parentCascader"
                placeholder="选择所属组织"
                clearable
              ></el-cascader>
            </el-form-item>
            <el-form-item label="组织类别" size="small" prop="typeId">
              <el-cascader
                :options="pullDownData.orgTypeList"
                :props="cascaderOption"
                :show-all-levels="false"
                v-model="orgDialogForm.typeId"
                @change="cascaderChange($event, 'typeCascader')"
                ref="typeCascader"
                placeholder="选择组织结构类别"
                clearable
              ></el-cascader>
            </el-form-item>
          </div>
          <div
            v-else-if="
              settingType == 'orgTypeTable' || settingType == 'orgTypeTree'
            "
            :key="2"
          >
            <el-form-item label="类别名称" size="small" prop="typeName">
              <el-input
                v-model="orgDialogForm.typeName"
                placeholder="组织结构类别名称"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="上级类别" size="small" prop="typeParentId">
              <el-cascader
                :options="pullDownData.orgTypeList"
                :props="cascaderOption"
                :show-all-levels="false"
                v-model="orgDialogForm.typeParentId"
                @change="cascaderChange($event, 'parentCascader')"
                ref="parentCascader"
                placeholder="选择所属类别"
                clearable
              ></el-cascader>
            </el-form-item>
          </div>
        </el-form>
        <el-form
          ref="addUserForm"
          :model="addUserForm"
          :rules="addUserRules"
          :label-width="labelWidth"
          v-else-if="
            tabPaneValue == 'user' &&
            (dialogTitle == '新建用户' || dialogTitle == '修改用户')
          "
          :key="2"
        >
          <el-form-item label="OA流程单：" size="small" prop="oa">
            <el-input
              v-model="addUserForm.oa"
              placeholder="申请帐号、调整岗位角色的OA流程单号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="工号：" size="small" prop="employeeNum">
            <el-input
              v-model="addUserForm.employeeNum"
              placeholder="如：18112601"
              clearable
              :disabled="dialogTitle == '修改用户'"
              @input="employeeNumChange"
            ></el-input>
          </el-form-item>
          <el-form-item label="姓名：" size="small" prop="name">
            <el-input
              v-model="addUserForm.name"
              placeholder="如：张三"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="邮箱：" size="small" prop="email">
            <el-input
              v-model="addUserForm.email"
              placeholder="公司分配个人邮箱"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="所属部门：" size="small" prop="organizationId">
            <el-cascader
              :options="pullDownData.organizationList"
              :props="cascaderOption"
              :show-all-levels="false"
              v-model="addUserForm.organizationId"
              @change="cascaderChange($event, 'orgDeptCascader')"
              ref="orgDeptCascader"
              placeholder="选择所属部门"
              clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item label="岗位" size="small" prop="workPositionId">
            <el-select
              v-model="addUserForm.workPositionId"
              placeholder="选择岗位"
              filterable
              clearable
            >
              <el-option-group
                v-for="group in positionList"
                :key="group.label"
                :label="group.label"
              >
                <el-option
                  v-for="item in group.options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item
            label="登录密码："
            size="small"
            prop="password"
            v-if="dialogTitle == '新建用户'"
          >
            <el-input
              style="position: absolute; height: 0; overflow: hidden"
            ></el-input>
            <el-input
              v-model="addUserForm.password"
              placeholder="输入登录密码"
              clearable
              show-password
              autocomplete="new-password"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号码：" size="small" prop="phoneNum">
            <el-input
              v-model="addUserForm.phoneNum"
              placeholder="输入手机号码"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="后台登录：" size="small" prop="allowLogin">
            <el-radio v-model="addUserForm.allowLogin" :label="true">允许登录</el-radio>
            <el-radio v-model="addUserForm.allowLogin" :label="false">禁止登录</el-radio>
          </el-form-item>
          <el-form-item label="测试环境：" size="small" prop="loginTest">
            <el-radio v-model="addUserForm.loginTest" :label="true">允许登录</el-radio>
            <el-radio v-model="addUserForm.loginTest" :label="false">禁止登录</el-radio>
          </el-form-item>
          <el-form-item label="SAP操作：" size="small" prop="sap">
            <el-radio v-model="addUserForm.sap" :label="true" 
              @change="isSapChange($event, true)">允许</el-radio>
            <el-radio v-model="addUserForm.sap" :label="false"
              @change="isSapChange($event, false)">禁止</el-radio>
          </el-form-item>
          <el-form-item label="加工工厂：" size="small" prop="sapWerks">
            <el-select v-model="addUserForm.sapWerks" placeholder="选择所在工厂"
                :disabled="!addUserForm.sap" filterable clearable>
              <el-option
                v-for="item in pullDownData.werksList"
                :key="item.weknr"
                :label="item.wektx"
                :value="item.weknr"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="销售工厂：" size="small" prop="sapSaleWerks">
            <el-select v-model="addUserForm.sapSaleWerks" placeholder="选择所在工厂"
                :disabled="!addUserForm.sap" filterable clearable>
              <el-option
                v-for="item in pullDownData.werksList"
                :key="item.weknr"
                :label="item.wektx"
                :value="item.weknr"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-form
          ref="resetUserForm"
          :model="resetUserForm"
          :rules="resetUserRules"
          :label-width="labelWidth"
          v-else-if="tabPaneValue == 'user' && dialogTitle == '重置用户密码'"
          :key="3"
          @submit.native.prevent
        >
          <el-form-item label="新密码：" size="small" prop="password">
            <el-input
              v-model="resetUserForm.password"
              placeholder="输入新密码"
              @keydown.enter.native="submitData('重置用户密码')"
              show-password
              clearable
            ></el-input>
          </el-form-item>
        </el-form>
      </template>
    </myDialog>
    <orderTableSelect
      ref="orderTableSelect"
      @orderTableSubmit="orderTableSubmit"
    ></orderTableSelect>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import myDialog from "@/components/myDialog.vue";
import orgTreePage from "./components/orgTreePage.vue";
import orgTypePage from "./components/orgTypePage.vue";
import orgTypeTreePage from "./components/orgTypeTreePage.vue";
import WorkPositionPage from "./components/WorkPositionPage.vue";
import WorkPositionTypePage from "./components/WorkPositionTypePage.vue";
import {
  apiOrgTable,
  apiOrgAdd,
  apiOrgUpdate,
  apiOrgDisable,
  apiOrgEnable,
  apiOrgMoveUp,
  apiOrgMoveDown,
  apiOrgTypeList,
  apiOrgTypeAdd,
  apiOrgTypeUpdate,
  apiOrgTypeDisable,
  apiOrgTypeEnable,
  apiOrgTypeMoveUp,
  apiOrgTypeMoveDown,
  apiUserSearch,
  apiOrgList,
  apiUserAdd,
  apiUserUpdate,
  apiUserResetPassword,
  apiUserDisable,
  apiUserEnable,
  apiPositionList,
  apiHandover
} from "@/api/userApi.js";
import orderTableSelect from "@/components/orderTableSelect.vue";
import {apiSapWerksList} from "@/api/SapOrder.js"
export default {
  lastModuleConfig: { modulePath: "/homePage/userManage", topTabVar: "tabPaneValue", topTabs: ["first", "user"], subTabs: { settingType: [], userType: [] } },
  components: {
    pagination,
    myDialog,
    orgTreePage,
    orgTypePage,
    orgTypeTreePage,
    WorkPositionPage,
    WorkPositionTypePage,
    orderTableSelect
  },
  data() {
    let validateEmail = (rule, value, callback) => {
      let reg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
      if (!value || reg.test(value)) {
        callback();
      } else {
        callback(new Error("邮箱格式错误"));
      }
    };
    return {
      tabPaneValue: "first",
      isMoreSearch: false,
      isShowTips: true,
      HandoverForm: {},
      pullDownData: {
        orgOptions: [],
        orgTypeList: [],
        organizationList: [],
        positionList: [],
        werksList:[]
      },
      // 联级配置
      cascaderOption: {
        checkStrictly: true,
        emitPath: false,
        label: "name",
        value: "id",
      },
      // ---组织结构---
      settingType: "orgTable",
      orgTableData: [],
      orgDialogForm: {},
      orgDialogRules: {
        name: [
          { required: true, message: "组织名称不能为空！", trigger: "blur" },
          {
            min: 2,
            max: 64,
            message: "长度在 2 到 64 个字符",
            trigger: "change",
          },
        ],
        parentId: [
          { required: true, message: "父级结构不能为空！", trigger: "change" },
        ],
        typeId: [
          { required: true, message: "组织类别不能为空！", trigger: "change" },
        ],
        typeName: [
          { required: true, message: "类别名称不能为空！", trigger: "blur" },
          {
            min: 2,
            max: 64,
            message: "长度在 2 到 64 个字符",
            trigger: "change",
          },
        ],
        typeParentId: [
          { required: true, message: "父级类别不能为空！", trigger: "change" },
        ],
      },
      typeId: "",
      // ---用户管理---
      userType: "userManage",
      // 用户管理查询条件
      searchConditionForm: {},
      // 岗位查询条件
      positionSearchForm: {},
      // 岗位类别查询条件
      positionTypeSearchForm: {},
      // tree配置
      defaultProps: {
        children: "children",
        label: "name",
      },
      orgList: [],
      currentDeptId: "",
      tableData: [],
      orderBy: [],
      desc: undefined,
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10,
      },
      // ---新建编辑对话框---
      dialogTitle: "",
      dialogForm: {},
      dialogRules: {
        userId: [
          { required: true, message: "工单的新所有者不能为空！", trigger: "change" },
        ],
      },
      addUserForm: {
        password : null
      },
      addUserRules: {
        oa: [
          { required: true, message: "OA流程单号不能为空！", trigger: "blur" }
        ],
        employeeNum: [
          { required: true, message: "工号不能为空！", trigger: "blur" },
          {
            min: 4,
            max: 64,
            message: "长度在 4 到 64 个字符",
            trigger: "blur",
          },
        ],
        name: [
          { required: true, message: "姓名不能为空！", trigger: "blur" },
          {
            min: 2,
            max: 64,
            message: "长度在 2 到 64 个字符",
            trigger: "blur",
          },
        ],
        email: [
          // { required: true, message: "邮箱不能为空！", trigger: "blur" },
          {
            validator: validateEmail,
            trigger: "change",
          },
        ],
        organizationId: [
          { required: true, message: "所属部门不能为空！", trigger: "change" },
        ],
        workPositionId: [
          { required: true, message: "岗位不能为空！", trigger: "change" },
        ],
        password: [
          { pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9a-zA-Z]{6,20}$/,
            message: "密码需为6-20位大小写字母、数字的组合",
            trigger: "blur"
          }
        ],
      },
      saveInfoObj: {
        // 用于新建用户每次打开需要缓存的数据
        workPositionId: "",
        allowLogin: true,
        loginTest: false,
        sap: false,
        sapWerks: "",
        sapSaleWerks: "",
        oa: ""
      },
      resetUserForm: {},
      resetUserRules: {
        password: [
          { required: true, message: "密码不能为空！", trigger: "blur" },
          {
            min: 6,
            max: 64,
            message: "长度在 6 到 64 个字符",
            trigger: "blur",
          },
        ],
      },
      labelWidth: "90px",
    };
  },
  watch: {
    tabPaneValue: function (newVal) {
      this.$moreSearchStyle();
      this.$nextTick(() => {
        if (newVal == "first") {
          this.getSettingData();
        } else if (newVal == "user") {
          this.getUserManage();
        }
      });
    },
  },
  methods: {
    isSapChange(val) {
      if(!val) {
        this.addUserForm.sapWerks='';
        this.addUserForm.sapSaleWerks='';
      }
    },
    // 查询条件-组装工单
    selectVisible(value, orderName, labelName) {
      if (value) {
        // console.log(orderName, labelName)
        this.$refs.orderTableSelect.labelName = labelName;
        this.$refs.orderTableSelect.orderName = orderName;
        this.$refs.orderTableSelect.parameter = {
          // customerId: this.dialogForm.customerId,
          // selectedRow: this.pullDownData.userList.filter((item) =>
          //   this.dialogForm.cartonOrderIds.includes(item.id)
          // ),
        };
        this.$refs.orderTableSelect.openDialog();
      }
    },
    // 订单表格提交
    orderTableSubmit({ orderName, selectRow }) {
      this.$set(this.HandoverForm, `${orderName + "Id"}`, selectRow.id);
      this.$set(this.pullDownData, `${orderName + "List"}`, [selectRow]);
    },
    // 交接工单
    handover(e, row) {
      this.dialogTitle = "工作交接";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: row.id
      };
    },
    // 切换一级面板
    tabPaneClick(tab) {
      this.tabPaneValue = tab.name;
    },
    // 切换组织结构子标签
    settingChange(value) {
      this.settingType = value;
      this.$moreSearchStyle();
      this.$nextTick(() => {
        this.getSettingData();
      });
    },
    // 切换用户管理子标签
    userTypeChange(value) {
      this.userType = value;
      this.$moreSearchStyle();
      this.$nextTick(() => {
        this.getUserManage();
      });
      if (this.userType == "userManage") {
        this.getPositionList();
        this.getSapWerksList();
      }
    },
    // 关闭温馨提示
    closeTips() {
      this.isShowTips = false;
      this.$moreSearchStyle();
    },
    // 组织架构--组织架构表格
    async getOrgTableData(remove, callback) {
      if (remove != "noRemove") {
        this.orgTableData = [];
      }
      const res = await apiOrgTable();
      // console.log(res);
      if (res.code == 0) {
        this.orgTableData = res.data;
        this.pullDownData.orgOptions = res.data;
        if (callback) callback();
      }
    },
    // 更多查询
    moreSearchBtn() {
      this.isMoreSearch = !this.isMoreSearch;
      this.$moreSearchStyle();
    },
    // 新建对话框
    addNewBtn(e, row) {
      if (this.tabPaneValue == "first") {
        this.$refs.myDialog.dialogVisible = true;
        if (this.settingType == "orgTable" || this.settingType == "orgTree") {
          this.dialogTitle = "新建组织";
          this.$set(this.orgDialogForm, "parentId", row ? row.id : "");
          this.$set(this.orgDialogForm, "typeId", this.typeId || "");
        } else if (
          this.settingType == "orgTypeTable" ||
          this.settingType == "orgTypeTree"
        ) {
          this.dialogTitle = "新建类别";
          this.$set(this.orgDialogForm, "typeParentId", row ? row.id : "");
        }
      } else if (this.tabPaneValue == "user") {
        if (this.userType == "userManage") {
          this.dialogTitle = "新建用户";
          this.$refs.myDialog.dialogVisible = true;
          this.$set(this.addUserForm, "organizationId", this.currentDeptId);
          this.$set(
            this.addUserForm,
            "workPositionId",
            this.saveInfoObj.workPositionId || undefined
          );
          this.$set(
            this.addUserForm,
            "allowLogin",
            this.saveInfoObj.allowLogin
          );
          this.$set(
            this.addUserForm,
            "loginTest",
            this.saveInfoObj.loginTest
          );
          this.$set(
            this.addUserForm,
            "sap",
            this.saveInfoObj.sap
          );
          this.$set(
            this.addUserForm,
            "oa",
            this.saveInfoObj.oa
          );
          this.$set(
            this.addUserForm,
            "sapWerks",
            this.saveInfoObj.sapWerks
          );
          this.$set(
            this.addUserForm,
            "sapSaleWerks",
            this.saveInfoObj.sapSaleWerks
          );
        } else if (this.userType == "workPosition") {
          this.$refs.WorkPositionPage.addPosition();
        } else if (this.userType == "workPositionType") {
          this.$refs.WorkPositionTypePage.addPositionType();
        }
      }
    },
    employeeNumChange(value){
      if(value){
        let pwd = "Aoni"+value;
        this.addUserForm.password = pwd;
      }else{
        this.addUserForm.password = "";
      }
    },
    // 修改组织架构
    editOrgInfo(e, row) {
      this.$refs.myDialog.dialogVisible = true;
      if (this.settingType == "orgTable" || this.settingType == "orgTree") {
        this.dialogTitle = "修改组织";
        this.orgDialogForm = {
          id: row.id,
          name: row.name,
          parentId: row.parent ? row.parent.id : undefined,
          typeId: row.type.id,
        };
      } else if (
        this.settingType == "orgTypeTable" ||
        this.settingType == "orgTypeTree"
      ) {
        this.dialogTitle = "修改类别";
        this.orgDialogForm = {
          id: row.id,
          typeName: row.name,
          typeParentId: row.parent ? row.parent.id : undefined,
        };
      }
    },
    // 组织架构-禁用
    disableOrg(e, row) {
      e.target.blur();
      let res = {};
      if (this.settingType == "orgTable" || this.settingType == "orgTree") {
        this.$allOperation(row, "禁用", "结构").then(async () => {
          res = await apiOrgDisable({
            id: row.id,
          });
          if (res.code == 0) {
            this.getSettingData("noRemove");
            this.$message({
              message: "禁用成功",
              type: "success",
            });
          }
        });
      } else if (
        this.settingType == "orgTypeTable" ||
        this.settingType == "orgTypeTree"
      ) {
        this.$allOperation(row, "禁用", "类别").then(async () => {
          res = await apiOrgTypeDisable({
            id: row.id,
          });
          if (res.code == 0) {
            this.getSettingData("noRemove");
            this.$message({
              message: "禁用成功",
              type: "success",
            });
          }
        });
      }
    },
    // 组织架构-启用
    enableOrg(e, row) {
      e.target.blur();
      let res;
      if (this.settingType == "orgTable" || this.settingType == "orgTree") {
        this.$allOperation(row, "启用", "结构").then(async () => {
          res = await apiOrgEnable({
            id: row.id,
          });
          if (res.code == 0) {
            this.getSettingData("noRemove");
            this.$message({
              message: "启用成功",
              type: "success",
            });
          }
        });
      } else if (
        this.settingType == "orgTypeTable" ||
        this.settingType == "orgTypeTree"
      ) {
        this.$allOperation(row, "启用", "类别").then(async () => {
          res = await apiOrgTypeEnable({
            id: row.id,
          });
          if (res.code == 0) {
            this.getSettingData("noRemove");
            this.$message({
              message: "启用成功",
              type: "success",
            });
          }
        });
      }
    },
    // 组织架构-上移
    moveUpOrg(e, row) {
      e.target.blur();
      let res = {};
      if (this.settingType == "orgTable" || this.settingType == "orgTree") {
        this.$confirm(`是否上移【${row.name}】？`, "上移结构", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          res = await apiOrgMoveUp({
            id: row.id,
          });
          if (res.code == 0) {
            this.getSettingData("noRemove");
            this.$message({
              message: "上移成功",
              type: "success",
            });
          }
        });
      } else if (
        this.settingType == "orgTypeTable" ||
        this.settingType == "orgTypeTree"
      ) {
        this.$confirm(`是否上移【${row.name}】？`, "上移类别", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          res = await apiOrgTypeMoveUp({
            id: row.id,
          });
          if (res.code == 0) {
            this.getSettingData("noRemove");
            this.$message({
              message: "上移成功",
              type: "success",
            });
          }
        });
      }
    },
    // 组织架构-下移
    moveDownOrg(e, row) {
      e.target.blur();
      let res = {};
      if (this.settingType == "orgTable" || this.settingType == "orgTree") {
        this.$confirm(`是否下移【${row.name}】？`, "下移结构", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          res = await apiOrgMoveDown({
            id: row.id,
          });
          if (res.code == 0) {
            this.getSettingData("noRemove");
            this.$message({
              message: "下移成功",
              type: "success",
            });
          }
        });
      } else if (
        this.settingType == "orgTypeTable" ||
        this.settingType == "orgTypeTree"
      ) {
        this.$confirm(`是否下移【${row.name}】？`, "下移类别", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          res = await apiOrgTypeMoveDown({
            id: row.id,
          });
          if (res.code == 0) {
            this.getSettingData("noRemove");
            this.$message({
              message: "下移成功",
              type: "success",
            });
          }
        });
      }
    },
    // 用户管理-左侧组织结构
    async getUserOrgList(remove, callback) {
      if (remove != "noRemove") {
        this.orgList = [];
      }
      const res = await apiOrgList();
      // console.log(res);
      if (res.code == 0) {
        this.orgList = res.data;
        this.pullDownData.organizationList = res.data;
        if (!this.currentDeptId) {
          this.currentDeptId = res.data[0].id;
        }
        this.getUserSearch();
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.currentDeptId);
        });
        if (callback) callback();
      }
    },
    // 用户管理-表格数据
    async getUserSearch(remove) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      const res = await apiUserSearch({
        ...this.searchConditionForm,
        organizationId: this.currentDeptId,
        orderBy: this.orderBy,
        desc: this.desc,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
      }
    },
    // tree点击
    handleNodeClick(data) {
      // console.log(data);
      if (this.currentDeptId == data.id) return;
      this.currentDeptId = data.id;
      this.pagination.currentPage = 1;
      this.getUserSearch();
    },
    // 修改用户信息
    handleEditInfo(row) {
      this.$refs.myDialog.dialogVisible = true;
      this.dialogTitle = "修改用户";
      this.addUserForm = {
        id: row.id,
        employeeNum: row.employeeNum,
        name: row.name,
        email: row.email,
        organizationId: row.organization.id,
        workPositionId: row.workPosition ? row.workPosition.id : undefined,
        phoneNum: row.phoneNum,
        allowLogin: row.isAllowLogin,
        loginTest: row.isLoginTest,
        sap: row.isSap,
        sapWerks: row.sapWerks,
        sapSaleWerks: row.sapSaleWerks
      };
    },
    // 重置用户密码
    resetUserPassword(row) {
      this.dialogTitle = "重置用户密码";
      this.$refs.myDialog.dialogVisible = true;
      this.resetUserForm.userId = row.id;
    },
    // 禁用用户
    disableUser(e, row) {
      e.target.blur();
      // 设置删除的提示内容
      const h = this.$createElement;
      this.$msgbox({
        title: `禁用用户`,
        message: h("div", null, [
          h("div", { class: "tips" }, [
            h("span", { class: "title" }, "温馨提示："),
            h("span", null, "禁用用户后，登录状态会被注销！"),
          ]),
          h("span", null, `输入完整的`),
          h("span", null, `用户名：【`),
          h("i", { style: "color: var(--themeColor)" }, row.name),
          h("span", null, `】以确认禁用！`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确定禁用`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue === row.name) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiUserDisable({
          id: row.id,
        });
        // console.log(res)
        if (res.code == 0) {
          this.getUserSearch();
          this.$message({
            message: "禁用成功",
            type: "success",
          });
        }
      });
    },
    // 启用用户
    enableUser(e, row) {
      e.target.blur();
      this.$allOperation(row, "启用", "用户").then(async () => {
        const res = await apiUserEnable({
          id: row.id,
        });
        // console.log(res)
        if (res.code == 0) {
          this.getUserSearch();
          this.$message({
            message: "启用成功",
            type: "success",
          });
        }
      });
    },
    // 确认对话框
    submitData(title) {
      let res = {};
      if (this.tabPaneValue == "first") {
        this.$refs.orgDialogForm.validate(async (valid) => {
          if (valid) {
            if (title == "新建组织") {
              res = await apiOrgAdd({
                ...this.orgDialogForm,
              });
              if (res.code == 0) {
                this.$refs.myDialog.dialogVisible = false;
                this.getSettingData("noRemove");
                this.$message({
                  message: "新建成功",
                  type: "success",
                });
              }
            } else if (title == "修改组织") {
              res = await apiOrgUpdate({
                ...this.orgDialogForm,
              });
              if (res.code == 0) {
                this.$refs.myDialog.dialogVisible = false;
                this.getSettingData("noRemove");
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
              }
            } else if (title == "新建类别") {
              res = await apiOrgTypeAdd({
                name: this.orgDialogForm.typeName,
                parentId: this.orgDialogForm.typeParentId,
              });
              if (res.code == 0) {
                this.$refs.myDialog.dialogVisible = false;
                this.getSettingData("noRemove");
                this.$message({
                  message: "新建成功",
                  type: "success",
                });
              }
            } else if (title == "修改类别") {
              res = await apiOrgTypeUpdate({
                id: this.orgDialogForm.id,
                name: this.orgDialogForm.typeName,
                parentId: this.orgDialogForm.typeParentId,
              });
              if (res.code == 0) {
                this.$refs.myDialog.dialogVisible = false;
                this.getSettingData("noRemove");
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
              }
            }
          } else {
            return false;
          }
        });
      } else if (this.tabPaneValue == "user") {
        if (title == "新建用户" || title == "修改用户") {
          this.$refs.addUserForm.validate(async (valid) => {
            if (valid) {
              if (title == "新建用户") {
                res = await apiUserAdd({
                  ...this.addUserForm,
                });
                if (res.code == 0) {
                  this.$refs.myDialog.dialogVisible = false;
                  this.pagination.currentPage = 1;
                  this.getUserSearch();
                  this.$message({
                    message: "新建成功",
                    type: "success",
                  });
                  this.saveInfoObj = {
                    workPositionId: this.addUserForm.workPositionId,
                    allowLogin: this.addUserForm.allowLogin,
                    loginTest: this.addUserForm.loginTest,
                    sap: this.addUserForm.sap,
                    sapWerks: this.addUserForm.sapWerks,
                    sapSaleWerks: this.addUserForm.sapSaleWerks,
                    oa: this.addUserForm.oa
                  };
                }
              } else if (title == "修改用户") {
                res = await apiUserUpdate({
                  ...this.addUserForm,
                });
                if (res.code == 0) {
                  this.$refs.myDialog.dialogVisible = false;
                  this.getUserSearch("noRemove");
                  this.$message({
                    message: "修改成功",
                    type: "success",
                  });
                }
              }
            } else {
              return false;
            }
          });
        } else if (title == "重置用户密码") {
          this.$refs.resetUserForm.validate(async (valid) => {
            if (valid) {
              const resetRes = await apiUserResetPassword({
                ...this.resetUserForm,
              });
              // console.log(resetRes)
              if (resetRes.code == 0) {
                this.$message({
                  message: "重置成功",
                  type: "success",
                });
                this.$refs.myDialog.dialogVisible = false;
              }
            } else {
              return false;
            }
          });
        } else if (title == "工作交接") {
          this.$refs.dialogForm.validate(async (valid) => {
          if (valid) {
              const res = await apiHandover({
                ...this.HandoverForm,
                id:this.dialogForm.id
              });
              if (res.code == 0) {
                this.$refs.myDialog.dialogVisible = false;
                this.getUserSearch();
                this.$message({
                  message: res.msg,
                  type: "success",
                });
              }
            }});}
      }
    },
    // 关闭对话框
    dialogClose(title) {
      if (this.tabPaneValue == "first") {
        if (this.settingType == "orgTable" || this.settingType == "orgTree") {
          this.typeId = this.orgDialogForm.typeId;
          this.$refs.parentCascader.$refs.panel.activePath = [];
          this.$refs.typeCascader.$refs.panel.activePath = [];
        } else if (
          this.settingType == "orgTypeTable" ||
          this.settingType == "orgTypeTree"
        ) {
          this.$refs.parentCascader.$refs.panel.activePath = [];
        }
        this.$refs.orgDialogForm.resetFields();
        this.orgDialogForm = {};
      } else if (this.tabPaneValue == "user") {
        if (title == "新建用户" || title == "修改用户") {
          this.$refs.orgDeptCascader.$refs.panel.activePath = [];
          this.$refs.addUserForm.resetFields();
          this.addUserForm = {};
        } else if (title == "重置用户密码") {
          this.$refs.resetUserForm.resetFields();
          this.resetUserForm = {};
        } else if (title == "工作交接") {
          this.HandoverForm={};
          this.dialogForm={};
        }
      }
    },
    // 清除查询
    onClear() {
      if (this.userType == "userManage") {
        this.pagination.currentPage = 1;
        this.searchConditionForm = {};
        this.getUserSearch();
      } else if (this.userType == "workPosition") {
        this.positionSearchForm = {};
        this.$refs.WorkPositionPage.pagination.currentPage = 1;
        this.$nextTick(() => {
          this.$refs.WorkPositionPage.getPositionSearch();
        });
      } else if (this.userType == "workPositionType") {
        this.positionTypeSearchForm = {};
        this.$refs.WorkPositionTypePage.pagination.currentPage = 1;
        this.$nextTick(() => {
          this.$refs.WorkPositionTypePage.getPositionTypeSearch();
        });
      }
    },
    // 确认查询
    onSearch() {
      if (this.userType == "userManage") {
        this.pagination.currentPage = 1;
        this.getUserSearch();
      } else if (this.userType == "workPosition") {
        this.$refs.WorkPositionPage.pagination.currentPage = 1;
        this.$refs.WorkPositionPage.getPositionSearch();
      } else if (this.userType == "workPositionType") {
        this.$refs.WorkPositionTypePage.pagination.currentPage = 1;
        this.$refs.WorkPositionTypePage.getPositionTypeSearch();
      }
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getUserSearch();
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getUserSearch();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getUserSearch();
    },
    // 联级选择器改变时触发
    cascaderChange(val, ref) {
      val && this.$refs[ref].toggleDropDownVisible();
    },
    // 组织结构类别下拉
    async getOrgTypeList() {
      const res = await apiOrgTypeList();
      if (res.code == 0) {
        this.pullDownData.orgTypeList = res.data;
      }
    },
    async getSapWerksList() {
      if (this.$store.state.userInfo && this.$store.state.userInfo.isSap) {
        const res = await apiSapWerksList();
        if (res.code == 0) {
          this.pullDownData.werksList = res.data;
        }
      }
    },
    // 用户管理-岗位下拉
    async getPositionList() {
      const res = await apiPositionList();
      if (res.code == 0) {
        let obj = {};
        let positionList = [];
        res.data.forEach((item) => {
          if (obj[item.workPositionType.name]) {
            positionList.forEach((pos) => {
              if (pos.label == item.workPositionType.name) {
                pos.options.push({
                  value: item.id,
                  label: item.name,
                });
              }
            });
          } else {
            obj[item.workPositionType.name] = 1;
            positionList.push({
              label: item.workPositionType.name,
              options: [
                {
                  value: item.id,
                  label: item.name,
                },
              ],
            });
          }
        });
        this.positionList = positionList;
      }
    },
    // 获取组织结构下的子标签表格数据汇总
    getSettingData(remove, callback) {
      if (this.settingType == "orgTable") {
        this.getOrgTableData(remove, callback);
      } else if (this.settingType == "orgTree") {
        this.$refs.orgTreePage.getOrgShow(remove, callback);
      } else if (this.settingType == "orgTypeTable") {
        this.$refs.orgTypePage.getOrgTypeTable(remove);
      } else if (this.settingType == "orgTypeTree") {
        this.$refs.orgTypeTreePage.getOrgTypeShow(remove);
      }
    },
    // 获取用户管理下的子标签表格数据汇总
    getUserManage(remove, callback) {
      if (this.userType == "userManage") {
        this.getUserOrgList(remove, callback);
      } else if (this.userType == "workPosition") {
        this.$refs.WorkPositionPage.getPositionTypeList(remove, callback);
      } else if (this.userType == "workPositionType") {
        this.$refs.WorkPositionTypePage.getPositionTypeSearch(remove, callback);
      }
    },
    downloadTreeImg() {
      let name =
        this.settingType == "orgTree" ? "组织结构树" : "组织结构类别树";
      this.$confirm(`确定导出【${name}】吗？`, "导出图片", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$canvasDownload(
          ".org-tree-container .org-tree .org-tree-node",
          name
        );
      });
    },
    callback() {
      this.getOrgTypeList();
      this.getPositionList();
      this.getSapWerksList();
    },
  },
  activated() {
    window.onresize = () => {
      document.querySelector(".contentBox").style.top =
        document.querySelector(".header").offsetHeight + "px";
    };
    if (this.tabPaneValue == "first") {
      this.getSettingData("", this.callback);
    } else if (this.tabPaneValue == "user") {
      this.getUserManage("", this.callback);
      this.saveInfoObj = {
        workPositionId: "",
        allowLogin: true,
        loginTest: false,
        sap: false
      };
    }
  },
  deactivated() {
    window.onresize = "";
  },
};
</script>

<style lang="less" scoped>
.disabled_user {
  text-decoration: line-through;
}
</style>